/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-19 11:12:31
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */

import { toVisualThousands } from "../utils";
import { labelFont, xAxisLabelColor, yAxisLabelColor } from "../visualConfig";


export default ({ title, list = [], color=[] }) => {

  return {
    title: {
      // text: 'World Population'
    },
    legend: {
      show: false,
    },

    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    color,
    grid: {
      left: 100,
      right: 0,
      bottom: 10,
      containLabel: false
    },
    xAxis: {
      show: false,
      type: 'category',
      data: title,
      axisLabel: { ...xAxisLabelColor },
    },
    yAxis: {
      type: 'value',
      boundaryGap: [0, 0.01],
      axisLine: { show: false },
      axisTick: { show: false },
      minorTick: { show: false },
      splitLine: { show: false },
      axisLabel: { ...yAxisLabelColor },
    },
    series: [
      {
        name: '2011',
        type: 'bar',
        data: list,
        label: {
          show: true,
          position: 'top',
          formatter: (ele) => toVisualThousands(ele.value),
          ...labelFont,
        }
      }
    ]
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P11/chart.js